import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import Timeline from '../components/Timeline';

const ResumePageStyles = styled.div`
  /* General Styles */
  .card {
    background-color: var(--gray-2);
  }

  i, .fab, .fas {
    padding: 5px;
    transition: color 0.3s ease;  /* Smooth transition for hover effect */
    color: var(--gray-1); /* Default icon color */
  }

  .btn {
    margin: 5px;
  }

  a {
    color: var(--gray-1);
    text-decoration: none; /* Remove underline by default */
  }

  .main {
    margin: auto;
    padding-top: 100px;
  }

  .center {
    margin: auto;
    width: 100%;
    text-align: center;
  }

  .padding {
    margin: auto;
    width: 80%;
  }

  /* Header Styling */
  #headerSection {
    text-align: center;
    margin-bottom: 20px;
  }

  #headerSection h1 {
  font-size: 5rem;
  }

  #headerDetails {
    font-size: 1rem;
    color: var(--gray-1);
  }

  #headerDetails a {
    color: var(--highlight-blue);
  }

  /* Header details text styles */
  #headerDetails {
    color: var(--gray-1);
    font-weight: 400;
    font-size: 1.5rem;
    margin-top: 10px;
  }

  #headerDetails a {
    color: inherit;  /* Inherit color from parent */
  }

  #headerDetails a:hover {
    color: var(--highlight-blue);  /* Change color when hovering over links */
        text-decoration: none;

  }
  
  #headerDetails:hover {
    color: var(--highlight-blue);  /* Change color when hovering over links */

  }

  /* Icon hover effect */
  .fab:hover, .fas:hover {
    color: var(--highlight-blue);  /* Change to blue color on hover */
  }

  .resume-page-text {
    font-size : 1.4rem;
  }

  /* Table Styling for Technical Skills */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }

  table td, table th {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid var(--gray-2);
  }

  table td {
    color: var(--gray-1);
    font-size: 1.2rem;
  }

  table th {
    background-color: var(--deep-dark);
    font-weight: bold;
    color: var(--gray-1);
  }

  table tr:nth-child(even) {
    // background-color: #f9f9f9; /* Alternate row background color */
  }

  table tr:hover {
    cursor: pointer;
  }

  /* ============================================================
     PRINT / DOWNLOAD CV — @media print
     Triggered by window.print() when user clicks Download CV.
     Forces accordions open, hides UI chrome, fixes colors for paper.
  ============================================================ */
  @media (max-width: 768px) {
    .cv-btn-wrapper {
      justify-content: center !important;
      padding: 0 0 20px !important;
    }
    .cv-btn-wrapper button {
      width: 100%;
      font-size: 1.8rem;
      padding: 14px 0;
    }
  }

  @media print {

    /* Hide the Download CV button itself */
    .no-print {
      display: none !important;
    }

    /* Remove top padding — no navbar needed on paper */
    .main {
      padding-top: 20px;
    }

    /* Use full width on paper */
    .padding {
      width: 95%;
    }

    /* Force ALL Bootstrap accordion panels open.
       Accordion.Body renders as .accordion-collapse.collapse
       By default collapse hides content — override that here */
    .accordion-collapse,
    .collapse {
      display: block !important;
      height: auto !important;
      visibility: visible !important;
    }

    /* Hide the accordion toggle arrows and the col-2 fab container — not useful in a PDF */
    .accordion-button::after,
    .fab-icon,
    .accordion-fab {
      display: none !important;
    }

    /* Make the title col take full width now that the fab col is gone */
    .accordion-button .col-10 {
      width: 100% !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
      text-align: center !important;
    }

    /* Center the accordion button content itself */
    .accordion-button {
      justify-content: center !important;
    }

    /* Dark theme text won't print well on white paper.
       Switch to dark on white for all text content */
    * {
      color: #111 !important;
      background-color: #fff !important;
    }

    /* ── Print Theme ──────────────────────────────────────────
       To recolour the PDF, change the 3 hex values below.
       primary   #2c3e50 — headings, HR, social links, table th
       secondary #4a7fa5 — role titles, sub-project names
       muted     #8fa4b0 — dates, tech tags
    ─────────────────────────────────────────────────────── */

    /* Name stays dark */
    #headerSection h1 { color: #111 !important; }

    /* Address, email, social links */
    #headerSection a,
    #headerSection #headerDetails { color: #2c3e50 !important; }

    /* HR accent line */
    hr {
      border-color: #2c3e50 !important;
      border-width: 1.5px !important;
      opacity: 0.6 !important;
    }

    /* Section headings: TECHNICAL SKILLS, WORK EXPERIENCE, EDUCATION */
    .about__info__heading,
    #timelineSection h3 { color: #2c3e50 !important; }

    /* Table category labels */
    table th { color: #2c3e50 !important; }

    /* Timeline: company stays dark, role gets secondary, date gets muted */
    .card-header h4 { color: #111 !important; }
    .card-header h5 { color: #4a7fa5 !important; }
    .card-header h6 { color: #8fa4b0 !important; }

    /* Sub-project name + tech footer */
    .sub-project__name { color: #4a7fa5 !important; }
    .card-footer h6    { color: #2c3e50 !important; }
    .sub-project__tech { color: #8fa4b0 !important; }

    /* All other links */
    a {
      color: #2c3e50 !important;
      text-decoration: none !important;
    }

    /* Education section — tighter headings, each entry on one line */
    #timelineSection h3 {
      font-size: 1.4rem !important;
      margin-bottom: 6px !important;
    }
    #timelineSection h4 {
      font-size: 1.1rem !important;
      margin: 0 !important;
    }
    #timelineSection span {
      font-size: 1.0rem !important;
    }
    #timelineSection .row {
      display: flex !important;
      align-items: baseline !important;
      gap: 12px !important;
      margin-bottom: 4px !important;
    }
    #timelineSection .col-3,
    #timelineSection .col-7,
    #timelineSection .col-2 {
      flex: none !important;
      width: auto !important;
    }

    /* Objective bullets — reduce by 2px (1.4rem → 1.1rem) */
    #objectiveSection .resume-page-text,
    #objectiveSection li {
      font-size: 1.1rem !important;
    }

    /* Table borders visible on paper */
    table td, table th {
      border-bottom: 1px solid #ccc !important;
      font-size: 1rem !important;
    }

    /* Prevent content from splitting awkwardly across pages */
    .accordion-item,
    .timeline-card,
    tr {
      page-break-inside: avoid;
    }

    /* Remove Bootstrap container-fluid side padding so hr and header
       text align flush with the rest of the content */
    .container-fluid {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    /* Ensure header title and hr are fully centered */
    #headerSection {
      text-align: center !important;
      width: 100% !important;
    }

    /* Reduce name size */
    #headerSection h1 {
      font-size: 2.8rem !important;
      margin-bottom: 4px !important;
    }

    /* Reduce address/contact details size */
    #headerSection #headerDetails {
      font-size: 1.2rem !important;
    }

    /* Collapse line breaks so contact + social flow on one line */
    #headerSection br {
      display: none !important;
    }

    /* Hide icon elements — they render as empty boxes in PDF */
    #headerSection i {
      display: none !important;
    }

    /* Show social links as readable text with separators */
    #headerSection a[href*="github"]::after {
      content: "github.com/ianasqazi";
      font-size: 1.2rem;
      color: #2c3e50 !important;
    }
    #headerSection a[href*="ianasqazi.ca"]::after {
      content: "ianasqazi.ca";
      font-size: 1.2rem;
      color: #2c3e50 !important;
    }
    #headerSection a[href*="linkedin"]::after {
      content: "linkedin.com/in/anasqazi";
      font-size: 1.2rem;
      color: #2c3e50 !important;
    }
    /* All 3 social links inline; force a line break before the first */
    #headerSection a[href*="github"] {
      display: inline;
    }
    #headerSection a[href*="github"]::before {
      content: "\\A";
      white-space: pre;
    }
    /* Separators between the 3 social links */
    #headerSection a[href*="ianasqazi.ca"]::before,
    #headerSection a[href*="linkedin"]::before {
      content: " | ";
      color: #555 !important;
    }
    /* Give header breathing room above the HR */
    #headerSection {
      padding-bottom: 8px !important;
    }

    hr {
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      margin-top: 12px !important;
      margin-bottom: 4px !important;
    }
  }
`;


export default function Resume() {
  return (
    <>
      <Helmet><title>Resume | Anas Qazi</title></Helmet>
      {/* Global print styles — hides nav/footer which live outside this component.
          ResumePageStyles is scoped so it can't reach them directly. */}
      <style>{`
        @media print {
          nav, footer, .site-footer { display: none !important; }
        }
        @page {
          margin: 1cm 1.5cm;
        }
      `}</style>

      <ResumePageStyles>
        <div className='main'>
          {/* no-print hides this button from the PDF itself */}
          <div className="no-print cv-btn-wrapper" style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0 20px 20px',
          }}>
            <button
              type="button"
              onClick={() => {
                const prev = document.title;
                document.title = 'Anas_Qazi_CV';
                window.addEventListener('afterprint', () => { document.title = prev; }, { once: true });
                window.print();
              }}
              style={{
                padding: '12px 32px',
                fontSize: '1.6rem',
                fontFamily: 'RobotoMono Regular, monospace',
                background: 'transparent',
                color: 'var(--highlight-blue)',
                border: '2px solid var(--highlight-blue)',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background 0.2s ease, color 0.2s ease',
                width: 'auto',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--highlight-blue)'; e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--highlight-blue)'; }}
            >
              Download CV
            </button>
          </div>

          {/* <!-- HEADER INFORMATION SECTION  --> */}
          <div className="padding">
            <div className="container-fluid" id="headerSection">
              <div className="row">
                <div className="col text-center">
                  <h1>Anas Qazi</h1>
                  <a href="https://goo.gl/maps/Pow2ANRwSmM8dNJC6" target="_blank" rel="noopener noreferrer"><span id="headerDetails">Toronto, Canada</span></a>&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
                  <a href="mailto:ianasqazi@gmail.com" rel="noopener noreferrer"><span id="headerDetails">ianasqazi@gmail.com</span></a>
                  <br />
                  <a href="https://github.com/ianasqazi" target="_blank" rel="noopener noreferrer"><i className="fab fa-github fa-4x"></i></a>
                  <a href="https://ianasqazi.ca/" target="_blank" rel="noopener noreferrer"><i className="fas fa-code fa-4x"></i></a>
                  <a href="https://www.linkedin.com/in/anasqazi/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin fa-4x"></i></a>
                  <br />
                </div>
                <br />
              </div>
              <hr style={{ borderColor: 'var(--gray-1)' }} />
            </div>
          </div>

          {/* <!-- OBJECTIVE SECTION  --> */}
          <div className="padding">
            <div className="container-fluid resume-page-text" id="objectiveSection">
              <div className="row">
                <div className="col">
                  <ul>
                    <li>• Versatile Full Stack Web Developer and Software Engineer with 10+ years of experience designing, developing, and deploying production-grade applications across diverse IT domains.</li>
                    <li>• Currently working as a Senior Software Engineer at Veriday, delivering enterprise-grade Liferay DXP and AWS solutions for fintech and banking clients including CIBC, Canadian Tire, and Laurentian Bank.</li>
                    <li>• Graduate of the Full Stack Web Development program at the University of Toronto, with expertise in modern frameworks, cloud technologies, and scalable architectures.</li>
                    <li>• Previous experience as an Oracle Consultant and Senior Database Administrator, with strong skills in database management, optimization, and enterprise solutions.</li>
                    <li>• Results-driven, collaborative professional with a strong track record of achieving project goals efficiently and effectively, while fostering teamwork and aligning with organizational objectives.</li>
                    <li>• Passionate about writing clean, maintainable code and continuously learning cutting-edge web technologies to drive innovation.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <br />

          {/* <!-- TECHNICAL SKILLS SECTION  --> */}
          <div className="padding" id="technical-skills-section">
            <div className="container-fluid resume-page-text">
              <div className="row">
                <div className="col">
                  <h3 className="about__info__heading">TECHNICAL SKILLS</h3>
                </div>
              </div>

              <table className="table">
                <tbody>
                  {/* Languages Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Languages</td>
                    <td>JavaScript (ES6+), HTML, CSS</td>
                  </tr>

                  {/* Frameworks Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Frameworks</td>
                    <td>React, Angular, Vue, Next.js, Flask, Django</td>
                  </tr>

                  {/* Libraries Section — runtime libraries only */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Libraries</td>
                    <td>Express.js, Node.js, GraphQL, Redux, jQuery, Bootstrap, Materialize, Axios, Feathers.js, SendGrid, Chart.js, jsPDF, Asyncio</td>
                  </tr>

                  {/* CI/CD & Build Tools */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>CI/CD & Build Tools</td>
                    <td>Jenkins, GitHub Actions, GitLab CI, CircleCI, Travis CI, AWS CodePipeline, CodeBuild, CodeDeploy, Webpack, Terraform</td>
                  </tr>

                  {/* Cloud & DevOps Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Cloud & DevOps</td>
                    <td>AWS (EC2, Fargate, ECS, Lambda, S3, RDS, Aurora, DynamoDB, ElastiCache, VPC, ELB, IAM, CloudFormation, CloudWatch, Auto Scaling, SNS, SQS), Docker, Kubernetes, DigitalOcean, Heroku</td>
                  </tr>

                  {/* Databases & Data Management Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Databases</td>
                    <td>MySQL, PostgreSQL, SQLite, SQL Server, MongoDB, Sequelize, Mongoose, Elasticsearch, Amazon ElastiCache</td>
                  </tr>

                  {/* Oracle Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Oracle</td>
                    <td>Oracle RAC, Data Guard, E-Business Suite (EBS), Enterprise Manager, Audit Vault & Database Firewall (AVDF), Database Vault (DBV), ASM, SAN, RMAN</td>
                  </tr>

                  {/* Version Control & Package Management Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Version Control & Package Management</td>
                    <td>Git, GitHub, Bitbucket, NPM, YARN, Pip, pipenv</td>
                  </tr>

                  {/* Operating Systems Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Operating Systems</td>
                    <td>Linux (Ubuntu, CentOS), Unix, HP-UX, Solaris, macOS, Windows</td>
                  </tr>

                  {/* Virtualization & Containers Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Virtualization & Containers</td>
                    <td>Docker, Kubernetes, Virtual Machines (VMs)</td>
                  </tr>

                  {/* Server Management Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Server Management</td>
                    <td>Apache, Nginx, Tomcat</td>
                  </tr>

                  {/* Liferay Section */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Liferay</td>
                    <td>Liferay DXP, Portal, Service Builder, Themes, Portlets, Liferay Analytics Cloud, Roles & Permissions, Authentication, WCAG 2.1/2.2 & AODA Compliance, Liferay IDE, Developer Studio, Workspace</td>
                  </tr>

                  {/* Other Tools Section — de-duplicated */}
                  <tr style={{ borderBottom: '1px solid var(--gray-1)' }}>
                    <td style={{ fontWeight: 'bold' }}>Other Tools</td>
                    <td>Postman, Swagger, Jira, Confluence, Asana, PRTG Network Monitor</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <br />

          {/* <!-- PROFESSIONAL EXPERIENCE SECTION  --> */}
          <Timeline />

          <br />

          {/* <!-- EDUCATION SECTION  --> */}
          <div className="padding">
                <div className="container-fluid resume-page-text" id="timelineSection">

                    <div className="row">
                        <div className="col">
                            <h3>EDUCATION</h3>
                        </div>
                    </div>

                    <br />

                    <div className="row">

                        <div className="col-3">
                            <h4>University of Toronto, Canada</h4>
                        </div>
                        <div className="col-7">
                            <span>Full Stack Web Development</span>
                        </div>
                        <div className="col-2">
                            <span>2020</span>
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-3">
                            <h4>University of Mumbai, India</h4>
                        </div>
                        <div className="col-7">
                            <span>Bachelor of Engineering - Computer Science</span>
                        </div>
                        <div className="col-2">
                            <span>2013</span>
                        </div>
                    </div>

                </div>
            </div>

            <br />

          {/* <!-- CERTIFICATIONS SECTION  --> */}
          <div className="padding">
            <div className="container-fluid" id="certificationSection">
              <div className="row">
                <div className="col">
                  {/* <h5 className="about__info__heading">CERTIFICATIONS</h5> */}
                </div>
              </div>

              <ul>
                {/* <li>• AWS Certified Solutions Architect – Associate (2023)</li>
                <li>• AWS Certified Developer – Associate (2023)</li>
                <li>• Full Stack Web Development – University of Toronto (2022)</li> */}
              </ul>
            </div>
          </div>

          <br />
        </div>
      </ResumePageStyles>
    </>
  );
}
